import LazyLoad from "vanilla-lazyload"

document.addEventListener("DOMContentLoaded", () => {
  const getVimeoPoster = (id) =>
    new Promise((resolve) => {
      fetch(`https://vimeo.com/api/v2/video/${id}.json`)
        .then((response) => response.text())
        .then((responseText) => resolve(JSON.parse(responseText)[0].thumbnail_large))
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error)
        })
    })

  const getSource = (type, id) =>
    new Promise((resolve) => {
      switch (type) {
        case "vimeo":
          getVimeoPoster(id).then((poster) =>
            resolve({
              poster,
              source: `https://player.vimeo.com/video/${id}?autoplay=1&color=fc0&byline=0`,
            }),
          )
          break

        case "youtube":
          resolve({
            poster: `https://img.youtube.com/vi/${id}/sddefault.jpg`,
            source: `https://www.youtube.com/embed/${id}?rel=0&showinfo=0&autoplay=1&rel=0&showinfo=0`,
          })
          break

        default:
          return undefined
      }
    })

  const loadFrame = (el, source) => {
    const iframe = document.createElement("iframe")
    iframe.setAttribute("frameborder", "0")
    iframe.setAttribute("allowfullscreen", "")
    iframe.setAttribute("src", source)
    el.classList.add("_play")
    el.appendChild(iframe)
    el.style.backgroundImage = ``
  }

  const preloadImage = (el, poster, source) => {
    el.classList.add("_loaded")
    if (poster) el.style.backgroundImage = `url('${poster}')`
    el.addEventListener("click", (e) => {
      loadFrame(e.target, source)
      window.dataLayer.push({ event: "bb.click.video" })
    })
  }

  // eslint-disable-next-line no-new
  new LazyLoad({
    elements_selector: "[data-video]",
    callback_enter: (e) => {
      const { type, id } = JSON.parse(e.dataset.video)

      getSource(type, id).then(({ poster, source }) => {
        const image = new Image()

        image.src = poster
        image.addEventListener("load", () => preloadImage(e, poster, source))
        image.addEventListener("error", () => preloadImage(e, poster, source))
      })
    },
  })
})



// WEBPACK FOOTER //
// ./src/blocks/02.projects/projects.js